import React, { useEffect, useState } from 'react';
import { useAuth } from '@/contexts/AuthContext';

const API_BASE = 'https://sportsmanager.com.br';

export default function ContratosPage() {
  const [contratos, setContratos] = useState([]);
  const [loading, setLoading] = useState(true);

  const { user } = useAuth();
  const tid = user?.tenant_id || user?.id || user?._id;

  useEffect(() => {
    async function carregarContratos() {
      try {
        const res = await fetch(`${API_BASE}/api/aluno/gestor/contratos?tid=${tid}`);
        const data = await res.json();
        setContratos(data);
      } catch (err) {
        console.error('Erro ao carregar contratos:', err);
      } finally {
        setLoading(false);
      }
    }

    if (tid) carregarContratos();
  }, [tid]);

  if (loading) return <div className="p-6">Carregando contratos...</div>;

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Contratos dos Alunos</h1>

      <div className="bg-zinc-900 rounded-lg shadow overflow-x-auto border border-zinc-800">
        <table className="w-full border-collapse">
          <thead>
            <tr className="bg-zinc-800 text-left text-white">
              <th className="p-3 text-zinc-200">Aluno</th>
              <th className="p-3 text-zinc-200">E-mail</th>
              <th className="p-3 text-zinc-200">Status</th>
              <th className="p-3 text-zinc-200">Contrato</th>
              <th className="p-3 text-zinc-200">Assinatura</th>
            </tr>
          </thead>
          <tbody>
            {contratos.map((c) => (
              <tr key={c.aluno_id} className="border-t border-zinc-800 text-zinc-200">
                <td className="p-3 text-zinc-200">{c.nome}</td>
                <td className="p-3 text-zinc-200">{c.email}</td>
                <td className="p-3 text-zinc-200">
                  {c.assinado ? (
                    <span className="text-green-600 font-semibold">Assinado</span>
                  ) : (
                    <span className="text-red-600 font-semibold">Pendente</span>
                  )}
                </td>
                <td className="p-3 text-zinc-200">
                  {c.pdf_url ? (
                    <a
                      href={`${API_BASE}${c.pdf_url}`}
                      target="_blank"
                      rel="noreferrer"
                      className="text-blue-600 underline"
                    >
                      Ver PDF
                    </a>
                  ) : (
                    '-'
                  )}
                </td>
                <td className="p-3 text-zinc-200">
                  {c.assinatura_url ? (
                    <a
                      href={`${API_BASE}${c.assinatura_url}`}
                      target="_blank"
                      rel="noreferrer"
                      className="text-blue-600 underline"
                    >
                      Ver assinatura
                    </a>
                  ) : (
                    '-'
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
